module.exports = {
          srcSet: __webpack_public_path__ + "784e3a49e44af7b1de7e6afca57ea88e-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "784e3a49e44af7b1de7e6afca57ea88e-120.png",width: 120,height: 42}],
          src: __webpack_public_path__ + "784e3a49e44af7b1de7e6afca57ea88e-120.png",
          toString:function(){return __webpack_public_path__ + "784e3a49e44af7b1de7e6afca57ea88e-120.png"},
          
          width: 120,
          height: 42
        }